<script lang="ts">
  import { Button } from "$lib/components/ui/button"
  import { MoveRight } from "lucide-svelte"
  import { getRequirement } from "../../utils"
  import { t, getCurrentLanguage } from "$lib/utils/i18n"

  interface Props {
    action: any
    processAction: (action: any) => void
  }

  let { action, processAction }: Props = $props()

  const language = getCurrentLanguage()

  const entries = getRequirement(action, "Entries") || 0

  let entryPluralized = $derived(
    t("widget_action_entries", {
      count: Number(entries),
    }),
  )

  function openUrl(action) {
    const url = action.requirements.find(
      (r) => r.name === "WhatsApp Url",
    )?.value
    window.open(url, "_blank")
  }
</script>

<div class="bg-white rounded-lg p-4 shadow-lg">
  <div class="mb-4">
    <h4 class="text-sm font-medium mb-2">
      {t("widget_action_worth", { count: entries, entries: entryPluralized })}
    </h4>
  </div>

  <Button
    variant="default"
    class="w-full bg-black text-white hover:bg-gray-800 flex items-center justify-center gap-2"
    onclick={() => {
      openUrl(action)
      processAction(action)
    }}
  >
    {(action.selectedAction || action.actions)?.translations?.[language]?.name}
    <MoveRight />
  </Button>
</div>
